import { routes } from "@/constants/routes";
import { Redirect } from "expo-router";

/** Die Mandanten-Einstellungen gibt es nicht mehr. */
export default function TenantSettingsRedirect() {
  return <Redirect href={routes.home} />;
}
